import { devtools } from 'config/devtools'
import { UseAppliedStatusFilters } from 'modules/statusFilters/store/useAppliedStatusFilters/types'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useAppliedStatusFilters = create<UseAppliedStatusFilters>()(
  devtools(
    persist(
      (set) => ({
        filters: null,
        set: (filters) => set({ filters }),
        clear: () => set({ filters: null }),
        filterInputs: {},
        setFilterInputs: (filterInputs) => set((prev) => ({ filterInputs: { ...prev.filterInputs, ...filterInputs } })),
        clearFilterInputs: () => set({ filterInputs: {} }),
      }),
      {
        name: 'statusFilters',
      },
    ),
    {
      store: 'statusFilters',
    },
  ),
)
